import { getCreditsOverview } from "../apis/workspace/billing";
import { useStoreBilling } from "../stores/useStoreBIlling";
import { useSmartQuery } from "./useSmartQuery";

export const useCreditOverview = (workspaceId) => {
  const { setCreditOverview, creditOverview } = useStoreBilling();

  // const shouldFetch = !!workspaceId && creditOverview && !creditOverview.summary;
  const shouldFetch = !!workspaceId;
  const query = useSmartQuery(
    ["get_credit_overview", workspaceId],
    () =>
      getCreditsOverview({
        options: { headers: { "X-Workspace-Id": workspaceId } },
      }),
    {
      condition: shouldFetch, // ✅ No need to return early
      zustandSetter: setCreditOverview,
    }
  );

  return {
    creditOverview,
    ...query,
  };
};
